import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useDetailStatusStore = defineStore('detailStatus', () => {
  const isShowDetailStatus = ref(false)
  const zoneTestIntervals = ref<any>({})

  const selectedFailedDot = ref()
  const incidentTicket = ref()
  const issueTicket = ref()
  //1-remedy;2-remedy&snow;3-snow
  const snowStatus = ref('1')
  const refreshIncidentTable = ref(0)
  const refreshIssueTable = ref(0)

  const markDownLog = ref('')
  const incidentDialogVisible = ref(false)
  const issueDialogVisible = ref(false)
  const checkStatus = ref()
  const incIssueNote = ref('')

  const isManualTestDetail = ref(false)
  const manuelTestDetailDate = ref<any>({})

  return {
    isShowDetailStatus,
    zoneTestIntervals,
    selectedFailedDot,
    incidentTicket,
    issueTicket,
    snowStatus,
    refreshIncidentTable,
    refreshIssueTable,
    markDownLog,
    incidentDialogVisible,
    issueDialogVisible,
    checkStatus,
    incIssueNote,
    isManualTestDetail,
    manuelTestDetailDate
  }
})
